import { useEffect, useState } from 'react';

import HorizontalContentText from './HorizontalContentText';
import { Container, Row, Col } from 'components/atoms/Grid';
import Text from 'components/atoms/Text';
import Button from 'components/atoms/Button';
import HorizontalRule from 'components/atoms/HorizontalRule';
import { sbEditable } from '@storyblok/storyblok-editable';
import styled from 'styled-components';
import Colors from 'components/tokens/Colors';
import { useDisplayedNews, useEditor } from 'providers/generalContext';
import RouterLink from 'components/atoms/RouterLink';
import { GetEducationArticles } from 'RenderItemStoryblok/Education/graphqlBuilder';

const fakeData = {
    tag: 'destaque',
    _uid: 'bead6ed9-24d1-44e7-8b4c-b8b686993e5e',
    title: 'Verificamos',
    button: [],
    component: 'checked_news',
    layout: 'layout_1',
    news: [
        {
            full_slug: 'news/e-falso-que-media-de-obitos-por-covid-19-com-biden-supera-a-de-bolsonaro',
            uuid: '28fad098-cbe2-4b2c-acf9-25474770c3e1',
            content: {
                featured_title: '',
                featured_image: { filename: 'https://picsum.photos/300' },
                resume: '',
                title: 'É falso que média de óbitos por Covid-19 com Biden supera a de Bolsonaro'
            }
        },
        {
            full_slug: 'news/e-falso-que-media-de-obitos-por-covid-19-com-biden-supera-a-de-bolsonaro',
            uuid: '28fad098-cbe2-4b2c-acf9-25474770c3e2',
            content: {
                featured_title: '',
                featured_image: { filename: 'https://picsum.photos/300' },
                resume: '',
                title: 'É falso que média de óbitos por Covid-19 com Biden supera a de Bolsonaro'
            }
        }
    ]
};

function CheckedNews(props) {
    const [educationNews, setEducationNews] = useState([]);
    const { displayedNews, setDisplayedNews } = useDisplayedNews();

    const indexOfLastComponent = Object.keys(displayedNews)
        ?.map(Number)
        .indexOf(props.index - 1);

    const usedNews = props.index - 1 >= 0 ? displayedNews?.[indexOfLastComponent]?.newsId : null;

    const tag = props.tag || 'educacao';
    const { getQuery, loading, data } = GetEducationArticles(tag, 2, usedNews?.join(','));

    const newsId = data?.EducationalarticleItems?.items.map(item => item.id);

    const encodeTag = encodeURIComponent(props.tag.trim().replace(/( )+/g, '-'));

    const { isStoryblokEditor } = useEditor();

    useEffect(() => {
        if (usedNews && !loading && !data?.EducationalarticleItems?.items?.length) {
            getQuery();
        }
        if (!loading && data?.EducationalarticleItems?.items?.length) {
            setEducationNews(data.EducationalarticleItems?.items);
        }
        // eslint-disable-next-line
    }, [usedNews, loading]);

    useEffect(() => {
        if (usedNews?.length > 0 && data?.EducationalarticleItems?.items?.length > 0) {
            setDisplayedNews(oldState => ({
                ...oldState,
                [props.index]: { newsId: Array.from(new Set([...usedNews, ...newsId])), ...oldState[props.index] }
            }));
        }

        if (usedNews === null && data?.EducationalarticleItems?.items?.length > 0) {
            setDisplayedNews(oldState => ({
                ...oldState,
                [props.index]: { newsId: newsId, ...oldState[props.index] }
            }));
        }

        //eslint-disable-next-line
    }, [loading, usedNews]);

    return (
        <Container {...sbEditable(props)} px="1.5 4">
            <Row mt="12" mb="0" justifyContent="space-between">
                <Col size="12 6" mb="3">
                    <Title>
                        <Row>
                            <Col size="12" mb="2" {...sbEditable(props.title)}>
                                <Text title size="32 48" lineHeight="30 40" hover>
                                    {props.title}
                                </Text>
                            </Col>
                            <Col size="4">
                                <HorizontalRule className="title-line" />
                            </Col>
                        </Row>
                    </Title>
                </Col>
                <Col size="12" order="1 3">
                    {!loading && educationNews
                        ? educationNews.map((item, index) => (
                              <Box key={item.uuid}>
                                  <Row mb="3 8">
                                      <Col>
                                          <HorizontalContentText reverse={index === 1} data={item} />
                                      </Col>
                                  </Row>
                                  {index === 0 && (
                                      <Row mb="2 8">
                                          <Col>
                                              <HorizontalRule className="line" />
                                          </Col>
                                      </Row>
                                  )}
                              </Box>
                          ))
                        : fakeData.news.map((item, index) => (
                              <Box key={item.uuid}>
                                  <Row mb="3 8">
                                      <Col>
                                          <HorizontalContentText reverse={index === 1} data={item} />
                                      </Col>
                                  </Row>
                                  {index === 0 && (
                                      <Row mb="2 8">
                                          <Col>
                                              <HorizontalRule className="line" />
                                          </Col>
                                      </Row>
                                  )}
                              </Box>
                          ))}
                </Col>
                <Col size="12 auto" order="2" mb="10" mt="5 0">
                    <RouterLink to={props.tag ? `categoria/${encodeTag}` : 'verificamos'} editor={isStoryblokEditor}>
                        <Button dark>{props.button_text}</Button>
                    </RouterLink>
                </Col>
            </Row>
        </Container>
    );
}

const Title = styled.div`
    :hover {
        .title-line {
            border-color: ${Colors.primary};
            transition: border-color 0.5s ease-in-out;
        }
    }
`;

const Box = styled.div`
    :hover {
        .line {
            border-color: ${Colors.lightGrey};
        }
    }
`;

export default CheckedNews;
